import * as React from 'react';
import './styles.scss';

export type BrandLogoProps = {};

export const BrandLogo = ({  }: BrandLogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 148.138 32.766"
    className="cmp-brand-logo"
  >
    <title>Enginuity</title>
    <g transform="translate(-337.194 -441.624)">
      <path
        d="M397.739,460.973v6.007h.068c0-3.993,2.082-6.348,5.563-6.348,3.788,0,6.007,2.594,6.007,7.031v10.444h-4.505V467.868c0-2.321-1.229-3.686-3.345-3.686-2.389,0-3.789,1.741-3.789,4.642v9.284h-4.505V460.973Z"
        transform="translate(-35.109 -11.908)"
      />
      <path
        d="M446.056,469.437c0-5.529,2.526-8.806,6.826-8.806,3.822,0,6.109,2.321,6.109,6.212h.068v-5.871h4.506v17.339c0,5.017-3.208,7.986-8.6,7.986-4.642,0-7.782-2.287-8.4-6.143l4.267-.648c.273,2.014,1.843,3.208,4.13,3.208a3.778,3.778,0,0,0,4.1-4.13v-6.553h-.068c0,3.891-2.287,6.212-6.109,6.212-4.3,0-6.826-3.276-6.826-8.806m8.908,5.222c3.072,0,4.335-2.526,4.335-5.222,0-2.662-1.263-5.256-4.335-5.256-2.73,0-4.335,1.98-4.335,5.256s1.6,5.222,4.335,5.222"
        transform="translate(-68.201 -11.908)"
      />
      <path
        d="M530.3,460.973v6.007h.068c0-3.993,2.082-6.348,5.563-6.348,3.789,0,6.007,2.594,6.007,7.031v10.444h-4.5V467.868c0-2.321-1.229-3.686-3.345-3.686-2.389,0-3.789,1.741-3.789,4.642v9.284H525.8V460.973Z"
        transform="translate(-118.158 -11.908)"
      />
      <path
        d="M583.123,461.545v10.24c0,2.321,1.194,3.652,3.208,3.652,2.253,0,3.584-1.707,3.584-4.642v-9.25h4.505v17.134h-4.505v-6.041h-.068c0,3.993-1.98,6.382-5.359,6.382-3.686,0-5.87-2.628-5.87-7.031V461.545Z"
        transform="translate(-151.25 -12.48)"
      />
      <rect
        width="4.505"
        height="17.134"
        transform="translate(447.055 449.065)"
      />
      <path
        d="M630.641,444.15a2.509,2.509,0,1,1,2.526,2.491,2.52,2.52,0,0,1-2.526-2.491"
        transform="translate(-183.842 0)"
      />
      <path
        d="M502.649,444.15a2.509,2.509,0,1,1,2.526,2.491,2.52,2.52,0,0,1-2.526-2.491"
        transform="translate(-103.656 0)"
      />
      <path
        d="M677.36,450.21l-3.891,16.827H673.4L669.51,450.21H654.256v-.068c2.73-.512,4.369-2.048,4.369-4.232v-2.458h-4.505v6.758h-2.73v3.106h2.457v8.84c0,3.481,2.15,5.529,5.8,5.529a9.288,9.288,0,0,0,3.72-.785v-3.345a4.922,4.922,0,0,1-2.287.546,2.411,2.411,0,0,1-2.731-2.526v-8.26h7.156l3.661,14.028h3.72l-2.082,7.85h4.813l6.553-24.984Z"
        transform="translate(-196.841 -1.145)"
      />
      <rect
        width="4.505"
        height="17.134"
        transform="translate(399.249 449.065)"
      />
      <path
        d="M337.194,443.452v13.713H341.7V447.1h12.186v-3.652Z"
        transform="translate(0 -1.145)"
      />
      <path
        d="M341.7,486.693v-6.526a13.714,13.714,0,0,0-4.505,10.178h17.047v-3.652Z"
        transform="translate(0 -24.147)"
      />
      <path
        d="M359.972,470.688a13.688,13.688,0,0,0-10.716,3.49h10.716Z"
        transform="translate(-7.557 -18.157)"
      />
    </g>
  </svg>
);
